import { ButtonProps, ButtonSize, ButtonVariant } from "./types";
import "./index.css";

const ButtonSpinner = () => (
  <svg
    className="animate-spin h-5 w-5 text-current"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

const Button = ({
  className = "",
  disabled,
  onClick,
  children,
  type,
  variant,
  size,
  isLoading = false,
}: ButtonProps) => {
  const buttonVariant =
    variant === ButtonVariant.PRIMARY
      ? "btn-primary"
      : variant === ButtonVariant.SECONDARY
      ? "btn-secondary"
      : variant === ButtonVariant.GHOST_LIGHT
      ? "btn-ghost-light"
      : variant === ButtonVariant.GHOST_DARK
      ? "btn-ghost-dark"
      : "";

  const buttonSize =
    size === ButtonSize.MEDIUM
      ? "btn-medium"
      : size === ButtonSize.SMALL
      ? "btn-small"
      : "";
  const loadingClass = isLoading ? "btn-loading" : "";
  const classNames = `btn ${buttonVariant} ${className} ${buttonSize} ${loadingClass}`;

  return (
    <button
      type={type}
      disabled={disabled}
      className={classNames}
      onClick={onClick}
    >
      {isLoading ? <ButtonSpinner /> : children}
    </button>
  );
};

export default Button;
